// ==========================================================================
// Type checking utils
// ==========================================================================

const getConstructor = input => (input !== null && typeof input !== 'undefined' ? input.constructor : null);
const instanceOf = (input, constructor) => Boolean(input && constructor && input instanceof constructor);
const isNullOrUndefined = input => input === null || typeof input === 'undefined';
const isObject = input => getConstructor(input) === Object;
const isString = input => getConstructor(input) === String;
const isArray = input => Array.isArray(input);
const isNodeList = input => instanceOf(input, NodeList);
const isElement = input => input !== null && typeof input === 'object' && input.nodeType === 1 && typeof input.style === 'object' && typeof input.ownerDocument === 'object';
const isEmpty = input => isNullOrUndefined(input) || ((isString(input) || isArray(input) || isNodeList(input)) && !input.length) || (isObject(input) && !Object.keys(input).length);

export default {
  nullOrUndefined: isNullOrUndefined,
  object: isObject,
  string: isString,
  nodeList: isNodeList,
  element: isElement,
  empty: isEmpty,
  array: isArray,
};
